import React from 'react';

import { Button, Group, useMantineTheme } from '@mantine/core';

import { EventDrawerState } from './types';

interface IFooterProps {
  state: EventDrawerState;
  setState: React.Dispatch<React.SetStateAction<EventDrawerState>>;
  closeHandler: () => void;
  formId: string;
  loadingSubmit: boolean;
}

const Footer = ({ state, setState, closeHandler, formId, loadingSubmit }: IFooterProps): JSX.Element => {
  const theme = useMantineTheme();

  const handleCancelEditEvent = (): void => {
    setState('view');
  };

  if (state !== 'view') {
    return (
      <Group position='right' px='md' py={theme.spacing.lg}>
        <Button variant='subtle' onClick={handleCancelEditEvent}>
          Cancel
        </Button>
        <Button form={formId} type='submit' color='green' loading={loadingSubmit} data-cy='saveClass'>
          Save
        </Button>
      </Group>
    );
  }

  return (
    <Group position='right' p={theme.spacing.lg}>
      <Button variant='subtle' onClick={closeHandler} data-cy='closeClass'>
        Close
      </Button>
    </Group>
  );
};
export default Footer;
